export default __webpack_public_path__ + "static/media/spin1.613b8025.png";